"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSubmitButton = exports.useDappRawSelectedTokens = exports.useSelectTokenCallback = exports.useOrdersTabs = exports.useSwitchTokens = exports.useToken = exports.useResetLimitPrice = exports.useSrcAmountNotZero = exports.useFormatNumber = exports.useOrderPastEvents = exports.useParseTokens = exports.useSetTokensFromDapp = exports.usePrepareUSDValues = exports.useOrdersHistoryQuery = exports.useBalanceQuery = exports.useHasAllowanceQuery = exports.useDstBalance = exports.useSrcBalance = exports.useDstUsd = exports.useSrcUsd = exports.useLoadingState = exports.useHistoryPrice = exports.useCancelOrder = exports.useCustomActions = exports.useLimitPrice = exports.useMarketPrice = exports.useChangeNetwork = exports.useUpdateStoreOveride = exports.useInitLib = exports.useCreateOrder = exports.useCreateSimpleLimitOrder = exports.useOnTokenSelect = exports.useApproveToken = exports.useUnwrapToken = exports.useWrapToken = exports.useReset = exports.useResetStore = void 0;
var twap_1 = require("@orbs-network/twap");
var context_1 = require("./context");
var web3_1 = __importDefault(require("web3"));
var react_1 = require("react");
var react_query_1 = require("@tanstack/react-query");
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var lodash_1 = __importDefault(require("lodash"));
var analytics_1 = require("./analytics");
var web3_candies_1 = require("@defi.org/web3-candies");
var store_1 = require("./store");
var consts_1 = require("./consts");
var enums_1 = require("./enums");
var react_number_format_1 = require("react-number-format");
/**
 * Actions
 */
var useResetStore = function () {
    var resetTwapStore = (0, store_1.useTwapStore)(function (state) { return state.reset; });
    var storeOverride = (0, context_1.useTwapContext)().storeOverride;
    return function () {
        resetTwapStore(storeOverride || {});
    };
};
exports.useResetStore = useResetStore;
var useReset = function () {
    var resetTwapStore = (0, store_1.useTwapStore)(function (state) { return state.reset; });
    var client = (0, react_query_1.useQueryClient)();
    var storeOverride = (0, context_1.useTwapContext)().storeOverride;
    return function () {
        client && client.invalidateQueries();
        resetTwapStore(storeOverride || {});
    };
};
exports.useReset = useReset;
var useWrapToken = function () {
    var lib = (0, store_1.useTwapStore)(function (state) { return state.lib; });
    var srcAmount = (0, store_1.useTwapStore)(function (state) { return state.getSrcAmount(); });
    var srcToken = (0, store_1.useTwapStore)(function (state) { return state.srcToken; });
    var dstToken = (0, store_1.useTwapStore)(function (state) { return state.dstToken; });
    var wizardStore = (0, store_1.useWizardStore)();
    var _a = useGasPriceQuery(), priorityFeePerGas = _a.priorityFeePerGas, maxFeePerGas = _a.maxFeePerGas;
    var setSrcToken = (0, store_1.useTwapStore)(function (state) { return state.setSrcToken; });
    var reset = (0, exports.useReset)();
    return (0, react_query_1.useMutation)(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            wizardStore.setAction(store_1.WizardAction.WRAP);
            wizardStore.setStatus(store_1.WizardActionStatus.PENDING);
            analytics_1.analytics.onWrapClick(srcAmount);
            return [2 /*return*/, lib.wrapNativeToken(srcAmount, priorityFeePerGas, maxFeePerGas)];
        });
    }); }, {
        onSuccess: function () {
            analytics_1.analytics.onWrapSuccess();
            wizardStore.setStatus(store_1.WizardActionStatus.SUCCESS);
            if ((lib === null || lib === void 0 ? void 0 : lib.validateTokens(srcToken, dstToken)) === twap_1.TokensValidation.wrapOnly) {
                reset();
                return;
            }
            setSrcToken(lib.config.wToken);
        },
        onError: function (error) {
            console.log(error.message);
            wizardStore.setStatus(store_1.WizardActionStatus.ERROR, error.message);
            analytics_1.analytics.onWrapError(error.message);
        },
    });
};
exports.useWrapToken = useWrapToken;
var useUnwrapToken = function () {
    var lib = (0, store_1.useTwapStore)(function (state) { return state.lib; });
    var _a = useGasPriceQuery(), priorityFeePerGas = _a.priorityFeePerGas, maxFeePerGas = _a.maxFeePerGas;
    var reset = (0, exports.useReset)();
    var srcTokenAmount = (0, store_1.useTwapStore)(function (state) { return state.getSrcAmount(); });
    var wizardStore = (0, store_1.useWizardStore)();
    return (0, react_query_1.useMutation)(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            wizardStore.setAction(store_1.WizardAction.UNWRAP);
            wizardStore.setStatus(store_1.WizardActionStatus.PENDING);
            return [2 /*return*/, lib === null || lib === void 0 ? void 0 : lib.unwrapNativeToken(srcTokenAmount, priorityFeePerGas, maxFeePerGas)];
        });
    }); }, {
        onSuccess: function () {
            reset();
            wizardStore.setStatus(store_1.WizardActionStatus.SUCCESS);
        },
        onError: function (error) {
            wizardStore.setStatus(store_1.WizardActionStatus.ERROR, error.message);
        },
    });
};
exports.useUnwrapToken = useUnwrapToken;
var useApproveToken = function () {
    var lib = (0, store_1.useTwapStore)(function (state) { return state.lib; });
    var srcAmount = (0, store_1.useTwapStore)(function (state) { return state.getSrcAmount(); });
    var _a = useGasPriceQuery(), priorityFeePerGas = _a.priorityFeePerGas, maxFeePerGas = _a.maxFeePerGas;
    var srcToken = (0, store_1.useTwapStore)(function (state) { return state.srcToken; });
    var refetch = (0, exports.useHasAllowanceQuery)().refetch;
    var wizardStore = (0, store_1.useWizardStore)();
    return (0, react_query_1.useMutation)(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    wizardStore.setAction(store_1.WizardAction.APPROVE);
                    wizardStore.setStatus(store_1.WizardActionStatus.PENDING);
                    analytics_1.analytics.onApproveClick(srcAmount);
                    return [4 /*yield*/, (lib === null || lib === void 0 ? void 0 : lib.approve(srcToken, srcAmount, priorityFeePerGas, maxFeePerGas))];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, refetch()];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, {
        onSuccess: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                analytics_1.analytics.onApproveSuccess();
                wizardStore.setStatus(store_1.WizardActionStatus.SUCCESS);
                return [2 /*return*/];
            });
        }); },
        onError: function (error) {
            console.log(error.message);
            wizardStore.setStatus(store_1.WizardActionStatus.ERROR, error.message);
            analytics_1.analytics.onApproveError(error.message);
        },
    });
};
exports.useApproveToken = useApproveToken;
var useOnTokenSelect = function (isSrc) {
    var srcSelect = (0, store_1.useTwapStore)(function (store) { return store.setSrcToken; });
    var dstSelect = (0, store_1.useTwapStore)(function (store) { return store.setDstToken; });
    return isSrc ? srcSelect : dstSelect;
};
exports.useOnTokenSelect = useOnTokenSelect;
var useCreateSimpleLimitOrder = function () {
    return (0, react_query_1.useMutation)(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, (0, exports.useCreateOrder)()];
        });
    }); });
};
exports.useCreateSimpleLimitOrder = useCreateSimpleLimitOrder;
var useCreateOrder = function () {
    var _a = useGasPriceQuery(), maxFeePerGas = _a.maxFeePerGas, priorityFeePerGas = _a.priorityFeePerGas;
    var store = (0, store_1.useTwapStore)();
    var wizardStore = (0, store_1.useWizardStore)();
    var reset = (0, exports.useReset)();
    var _b = (0, context_1.useTwapContext)(), askDataParams = _b.askDataParams, onTxSubmitted = _b.onTxSubmitted;
    var dstUSD = (0, store_1.useTwapStore)(function (state) { return state.getDstAmountUsdUi(); });
    var setTokensFromDapp = (0, exports.useSetTokensFromDapp)();
    return (0, react_query_1.useMutation)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var fillDelayMillis, dstToken;
        return __generator(this, function (_a) {
            onTxSubmitted === null || onTxSubmitted === void 0 ? void 0 : onTxSubmitted({
                srcToken: store.srcToken,
                dstToken: store.dstToken,
                srcAmount: store.getSrcAmount().toString(),
                dstUSD: dstUSD,
                dstAmount: store.getDstAmount().toString(),
            });
            wizardStore.setAction(store_1.WizardAction.CREATE_ORDER);
            wizardStore.setStatus(store_1.WizardActionStatus.PENDING);
            fillDelayMillis = (store.getFillDelayUiMillis() - store.lib.estimatedDelayBetweenChunksMillis()) / 1000;
            analytics_1.analytics.onConfirmationCreateOrderClick();
            store.setLoading(true);
            dstToken = __assign(__assign({}, store.dstToken), { address: store.lib.validateTokens(store.srcToken, store.dstToken) === twap_1.TokensValidation.dstTokenZero ? web3_candies_1.zeroAddress : store.dstToken.address });
            return [2 /*return*/, store.lib.submitOrder(store.srcToken, dstToken, store.getSrcAmount(), store.getSrcChunkAmount(), store.getDstMinAmountOut(), store.getDeadline(), fillDelayMillis, store.srcUsd, askDataParams, priorityFeePerGas || web3_candies_1.zero, maxFeePerGas)];
        });
    }); }, {
        onSuccess: function (id) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                analytics_1.analytics.onCreateOrderSuccess(id);
                reset();
                store.setOrderCreatedTimestamp(Date.now());
                setTokensFromDapp();
                wizardStore.setStatus(store_1.WizardActionStatus.SUCCESS);
                return [2 /*return*/];
            });
        }); },
        onError: function (error) {
            analytics_1.analytics.onCreateOrderError(error.message);
            if (error.code === 4001) {
                analytics_1.analytics.onCreateOrderRejected();
            }
            wizardStore.setStatus(store_1.WizardActionStatus.ERROR, error.message);
        },
        onSettled: function () {
            store.setLoading(false);
        },
    });
};
exports.useCreateOrder = useCreateOrder;
var useInitLib = function () {
    var setTwapLib = (0, store_1.useTwapStore)(function (state) { return state.setLib; });
    var setWrongNetwork = (0, store_1.useTwapStore)(function (state) { return state.setWrongNetwork; });
    return function (props) { return __awaiter(void 0, void 0, void 0, function () {
        var chain, _a, wrongChain;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!props.provider || !props.account) {
                        setTwapLib(undefined);
                        setWrongNetwork(undefined);
                        return [2 /*return*/];
                    }
                    _a = props.connectedChainId;
                    if (_a) return [3 /*break*/, 2];
                    return [4 /*yield*/, new web3_1.default(props.provider).eth.getChainId()];
                case 1:
                    _a = (_b.sent());
                    _b.label = 2;
                case 2:
                    chain = _a;
                    wrongChain = props.config.chainId !== chain;
                    setWrongNetwork(wrongChain);
                    console.log("props.provider", props.provider);
                    setTwapLib(wrongChain ? undefined : new twap_1.TWAPLib(props.config, props.account, props.provider));
                    return [2 /*return*/];
            }
        });
    }); };
};
exports.useInitLib = useInitLib;
var useUpdateStoreOveride = function () {
    var setStoreOverrideValues = (0, store_1.useTwapStore)(function (state) { return state.setStoreOverrideValues; });
    return (0, react_1.useCallback)(function (values) {
        setStoreOverrideValues(values || {});
    }, [setStoreOverrideValues]);
};
exports.useUpdateStoreOveride = useUpdateStoreOveride;
var useChangeNetwork = function () {
    var _a = (0, context_1.useTwapContext)(), config = _a.config, _provider = _a.provider, account = _a.account, storeOverride = _a.storeOverride;
    var _b = (0, react_1.useState)(false), loading = _b[0], setLoading = _b[1];
    var initLib = (0, exports.useInitLib)();
    var setInvalidChain = (0, store_1.useTwapStore)(function (state) { return state.setWrongNetwork; });
    var changeNetwork = function (onSuccess, onError) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    (0, web3_candies_1.setWeb3Instance)(new web3_1.default(_provider));
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, (0, web3_candies_1.switchMetaMaskNetwork)(config.chainId)];
                case 2:
                    _a.sent();
                    onSuccess();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    onError();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var onChangeNetwork = function () { return __awaiter(void 0, void 0, void 0, function () {
        var onSuccess, onError;
        return __generator(this, function (_a) {
            onSuccess = function () {
                setInvalidChain(false);
                setLoading(false);
                initLib({ config: config, provider: _provider, account: account, storeOverride: storeOverride });
            };
            onError = function () {
                setLoading(false);
            };
            setLoading(true);
            changeNetwork(onSuccess, onError);
            return [2 /*return*/];
        });
    }); };
    return {
        changeNetwork: onChangeNetwork,
        loading: loading,
    };
};
exports.useChangeNetwork = useChangeNetwork;
var useMarketPrice = function () {
    var _a = (0, react_1.useState)(false), inverted = _a[0], setInverted = _a[1];
    var _b = (0, store_1.useTwapStore)(function (state) { return state.getMarketPrice(inverted); }), leftToken = _b.leftToken, rightToken = _b.rightToken, marketPrice = _b.marketPriceUi, loading = _b.loading;
    return {
        leftToken: leftToken,
        rightToken: rightToken,
        marketPrice: marketPrice,
        toggleInverted: function () { return setInverted(!inverted); },
        loading: loading,
    };
};
exports.useMarketPrice = useMarketPrice;
var useLimitPrice = function () {
    var _a = (0, react_1.useState)(false), inverted = _a[0], setInverted = _a[1];
    var translations = (0, context_1.useTwapContext)().translations;
    var _b = (0, store_1.useTwapStore)(function (state) { return ({
        isLimitOrder: state.isLimitOrder,
        setLimitPrice: state.setLimitPriceUi,
        custom: state.limitPriceUi.custom,
    }); }), isLimitOrder = _b.isLimitOrder, setLimitPrice = _b.setLimitPrice, custom = _b.custom;
    var _c = (0, store_1.useTwapStore)(function (state) { return state.getLimitPrice(inverted); }), limitPrice = _c.limitPriceUi, leftToken = _c.leftToken, rightToken = _c.rightToken;
    var onChange = (0, react_1.useCallback)(function (amountUi) {
        if (amountUi === void 0) { amountUi = ""; }
        setLimitPrice({ priceUi: amountUi, inverted: inverted });
    }, [inverted]);
    var toggleInverted = (0, react_1.useCallback)(function () {
        setInverted(!inverted);
    }, [inverted]);
    var loading = (0, exports.useLoadingState)();
    return {
        toggleInverted: toggleInverted,
        onChange: onChange,
        limitPrice: limitPrice,
        leftToken: leftToken,
        rightToken: rightToken,
        warning: !leftToken || !rightToken ? translations === null || translations === void 0 ? void 0 : translations.selectTokens : undefined,
        isLimitOrder: isLimitOrder,
        isLoading: loading.srcUsdLoading || loading.dstUsdLoading,
        custom: custom,
    };
};
exports.useLimitPrice = useLimitPrice;
var useCustomActions = function () {
    var onPercentClick = (0, store_1.useTwapStore)(function (store) { return store.setSrcAmountPercent; });
    return { onPercentClick: onPercentClick };
};
exports.useCustomActions = useCustomActions;
var useCancelOrder = function () {
    var lib = (0, store_1.useTwapStore)(function (state) { return state.lib; });
    var refetch = (0, exports.useOrdersHistoryQuery)().refetch;
    var _a = useGasPriceQuery(), priorityFeePerGas = _a.priorityFeePerGas, maxFeePerGas = _a.maxFeePerGas;
    return (0, react_query_1.useMutation)(function (orderId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            analytics_1.analytics.onCancelOrderClick(orderId);
            return [2 /*return*/, lib === null || lib === void 0 ? void 0 : lib.cancelOrder(orderId, priorityFeePerGas, maxFeePerGas)];
        });
    }); }, {
        onSuccess: function (_result, orderId) {
            analytics_1.analytics.onCancelOrderSuccess(orderId.toString());
            refetch();
        },
        onError: function (error) {
            analytics_1.analytics.onCancelOrderError(error.message);
        },
    });
};
exports.useCancelOrder = useCancelOrder;
var useHistoryPrice = function (order) {
    var _a = (0, react_1.useState)(false), inverted = _a[0], setInverted = _a[1];
    var price = inverted ? (0, bignumber_js_1.default)(1).div(order.ui.dstPriceFor1Src) : order.ui.dstPriceFor1Src;
    return {
        inverted: inverted,
        toggleInverted: function () { return setInverted(!inverted); },
        price: price,
        priceUi: price.toFormat(),
        leftToken: inverted ? order.ui.dstToken : order.ui.srcToken,
        rightToken: !inverted ? order.ui.dstToken : order.ui.srcToken,
    };
};
exports.useHistoryPrice = useHistoryPrice;
var useLoadingState = function () {
    var _a, _b;
    var srcToken = (0, store_1.useTwapStore)(function (store) { return store.srcToken; });
    var dstToken = (0, store_1.useTwapStore)(function (store) { return store.dstToken; });
    var srcUSD = (0, exports.useSrcUsd)();
    var dstUSD = (0, exports.useDstUsd)();
    var srcBalance = (0, exports.useSrcBalance)();
    var dstBalance = (0, exports.useDstBalance)();
    return {
        srcUsdLoading: (!srcToken && false) || srcUSD.isLoading || ((_a = srcUSD.data) === null || _a === void 0 ? void 0 : _a.isZero()),
        dstUsdLoading: (dstToken && !dstUSD.data) || dstUSD.isLoading || ((_b = dstUSD.data) === null || _b === void 0 ? void 0 : _b.isZero()),
        srcBalanceLoading: srcBalance.isLoading,
        dstBalanceLoading: dstBalance.isLoading,
    };
};
exports.useLoadingState = useLoadingState;
var useSrcUsd = function () {
    var srcToken = (0, store_1.useTwapStore)(function (store) { return store.srcToken; });
    var setSrcUsd = (0, store_1.useTwapStore)(function (store) { return store.setSrcUsd; });
    return useUsdValueQuery(srcToken, setSrcUsd);
};
exports.useSrcUsd = useSrcUsd;
var useDstUsd = function () {
    var dstToken = (0, store_1.useTwapStore)(function (store) { return store.dstToken; });
    var setDstUsd = (0, store_1.useTwapStore)(function (store) { return store.setDstUsd; });
    return useUsdValueQuery(dstToken, setDstUsd);
};
exports.useDstUsd = useDstUsd;
var useSrcBalance = function () {
    var srcToken = (0, store_1.useTwapStore)(function (store) { return store.srcToken; });
    var setSrcBalance = (0, store_1.useTwapStore)(function (store) { return store.setSrcBalance; });
    return (0, exports.useBalanceQuery)(srcToken, setSrcBalance);
};
exports.useSrcBalance = useSrcBalance;
var useDstBalance = function () {
    var dstToken = (0, store_1.useTwapStore)(function (store) { return store.dstToken; });
    var setDstBalance = (0, store_1.useTwapStore)(function (store) { return store.setDstBalance; });
    return (0, exports.useBalanceQuery)(dstToken, setDstBalance);
};
exports.useDstBalance = useDstBalance;
/**
 * Queries
 */
var useHasAllowanceQuery = function () {
    var _a = (0, store_1.useTwapStore)(function (state) { return ({
        lib: state.lib,
        amount: state.getSrcAmount(),
        srcToken: state.srcToken,
    }); }), lib = _a.lib, amount = _a.amount, srcToken = _a.srcToken;
    var query = (0, react_query_1.useQuery)([enums_1.QueryKeys.GET_ALLOWANCE, lib === null || lib === void 0 ? void 0 : lib.config.chainId, srcToken === null || srcToken === void 0 ? void 0 : srcToken.address, amount.toString()], function () { return lib.hasAllowance(srcToken, amount); }, {
        enabled: !!lib && !!srcToken && amount.gt(0),
        staleTime: consts_1.STALE_ALLOWANCE,
        refetchOnWindowFocus: true,
    });
    return __assign(__assign({}, query), { isLoading: query.isLoading && query.fetchStatus !== "idle" });
};
exports.useHasAllowanceQuery = useHasAllowanceQuery;
var useGetPriceUsdCallback = function () {
    var lib = (0, store_1.useTwapStore)(function (state) { return state.lib; });
    var _a = (0, context_1.useTwapContext)(), priceUsdFromProps = _a.priceUsd, disablePriceUsdFetch = _a.disablePriceUsdFetch;
    return function (token) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, res, _b, error_2, _c, error_3;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!lib || !token)
                        return [2 /*return*/, (0, bignumber_js_1.default)(0)];
                    if (!(disablePriceUsdFetch && priceUsdFromProps)) return [3 /*break*/, 2];
                    _a = bignumber_js_1.default.bind;
                    return [4 /*yield*/, priceUsdFromProps(token)];
                case 1: return [2 /*return*/, new (_a.apply(bignumber_js_1.default, [void 0, (_d.sent()) || web3_candies_1.zero]))()];
                case 2:
                    _d.trys.push([2, 4, , 9]);
                    console.log({ token: token });
                    _b = bignumber_js_1.default.bind;
                    return [4 /*yield*/, lib.priceUsd(token)];
                case 3:
                    res = new (_b.apply(bignumber_js_1.default, [void 0, _d.sent()]))();
                    return [2 /*return*/, res];
                case 4:
                    error_2 = _d.sent();
                    if (!priceUsdFromProps) return [3 /*break*/, 8];
                    _d.label = 5;
                case 5:
                    _d.trys.push([5, 7, , 8]);
                    _c = bignumber_js_1.default.bind;
                    return [4 /*yield*/, priceUsdFromProps(token)];
                case 6: return [2 /*return*/, new (_c.apply(bignumber_js_1.default, [void 0, _d.sent()]))()];
                case 7:
                    error_3 = _d.sent();
                    throw new Error();
                case 8: throw new Error();
                case 9: return [2 /*return*/];
            }
        });
    }); };
};
var useUsdValueQuery = function (token, onSuccess) {
    var lib = (0, store_1.useTwapStore)(function (state) { return state.lib; });
    var priceUsd = useGetPriceUsdCallback();
    var disablePriceUsdFetch = (0, context_1.useTwapContext)().disablePriceUsdFetch;
    var address = (0, react_1.useRef)("");
    var client = (0, react_query_1.useQueryClient)();
    var key = [enums_1.QueryKeys.GET_USD_VALUE, token === null || token === void 0 ? void 0 : token.address];
    var query = (0, react_query_1.useQuery)(key, function () { return __awaiter(void 0, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (address.current !== (token === null || token === void 0 ? void 0 : token.address)) {
                        onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(client.getQueryData(key) || (0, bignumber_js_1.default)(0));
                        address.current = (token === null || token === void 0 ? void 0 : token.address) || "";
                    }
                    return [4 /*yield*/, priceUsd(token)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, res];
            }
        });
    }); }, {
        enabled: !!lib && !!token && !!priceUsd && !disablePriceUsdFetch,
        onSuccess: onSuccess,
        refetchInterval: consts_1.REFETCH_USD,
    });
    return __assign(__assign({}, query), { isLoading: query.isLoading && query.fetchStatus !== "idle" });
};
var useBalanceQuery = function (token, onSuccess, staleTime) {
    var lib = (0, store_1.useTwapStore)(function (state) { return state.lib; });
    var key = [enums_1.QueryKeys.GET_BALANCE, lib === null || lib === void 0 ? void 0 : lib.maker, token === null || token === void 0 ? void 0 : token.address];
    var address = (0, react_1.useRef)("");
    var client = (0, react_query_1.useQueryClient)();
    var query = (0, react_query_1.useQuery)(key, function () {
        if (address.current !== (token === null || token === void 0 ? void 0 : token.address)) {
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(client.getQueryData(key) || (0, bignumber_js_1.default)(0));
            address.current = (token === null || token === void 0 ? void 0 : token.address) || "";
        }
        return lib.makerBalance(token);
    }, {
        enabled: !!lib && !!token,
        onSuccess: onSuccess,
        refetchInterval: consts_1.REFETCH_BALANCE,
        staleTime: staleTime,
    });
    return __assign(__assign({}, query), { isLoading: query.isLoading && query.fetchStatus !== "idle" });
};
exports.useBalanceQuery = useBalanceQuery;
var useGasPriceQuery = function () {
    var _a = (0, context_1.useTwapContext)(), contextMax = _a.maxFeePerGas, contextTip = _a.priorityFeePerGas;
    var lib = (0, store_1.useTwapStore)(function (state) { return state.lib; });
    var _b = (0, react_query_1.useQuery)([enums_1.QueryKeys.GET_GAS_PRICE, contextTip, contextMax], function () { return (0, web3_candies_1.estimateGasPrice)(); }, {
        enabled: !!lib,
        refetchInterval: consts_1.REFETCH_GAS_PRICE,
    }), isLoading = _b.isLoading, data = _b.data;
    var priorityFeePerGas = bignumber_js_1.default.max((data === null || data === void 0 ? void 0 : data.fast.tip) || 0, contextTip || 0);
    var maxFeePerGas = bignumber_js_1.default.max((data === null || data === void 0 ? void 0 : data.fast.max) || 0, contextMax || 0, priorityFeePerGas);
    return {
        isLoading: isLoading,
        maxFeePerGas: maxFeePerGas,
        priorityFeePerGas: priorityFeePerGas,
    };
};
var useTokenList = function () {
    var tokens = (0, context_1.useTwapContext)().tokenList || [];
    var lib = (0, store_1.useTwapStore)(function (store) { return store.lib; });
    var tokensLength = lodash_1.default.size(tokens);
    return (0, react_1.useMemo)(function () {
        if (!lib || !tokensLength)
            return [];
        if (!tokens.find(function (it) { return lib.isNativeToken(it); })) {
            tokens.push(lib.config.nativeToken);
        }
        if (!tokens.find(function (it) { return lib.isWrappedToken(it); })) {
            tokens.push(lib.config.wToken);
        }
        return tokens;
    }, [lib, tokensLength]);
};
var useOrdersHistoryQuery = function (_priceUsd) {
    var tokenList = useTokenList();
    var orderCreatedTimestamp = (0, store_1.useTwapStore)(function (state) { return state.orderCreatedTimestamp; });
    var lib = (0, store_1.useTwapStore)(function (state) { return state.lib; });
    var getUsdValues = (0, exports.usePrepareUSDValues)(_priceUsd);
    var query = (0, react_query_1.useQuery)([enums_1.QueryKeys.GET_ORDER_HISTORY, lib === null || lib === void 0 ? void 0 : lib.maker, lib === null || lib === void 0 ? void 0 : lib.config.chainId, orderCreatedTimestamp], function () { return __awaiter(void 0, void 0, void 0, function () {
        var orders, tokens, tokensWithUsd, parsedOrders;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, lib.getAllOrders()];
                case 1:
                    orders = _a.sent();
                    tokens = lodash_1.default.compact(lodash_1.default.uniqBy(lodash_1.default.concat(lodash_1.default.map(orders, function (o) { return lodash_1.default.find(tokenList, function (t) { return (0, web3_candies_1.eqIgnoreCase)(t.address, o.ask.srcToken); }); }), lodash_1.default.map(orders, function (o) { return lodash_1.default.find(tokenList, function (t) { return (0, web3_candies_1.eqIgnoreCase)(t.address, o.ask.dstToken); }); })), function (t) { return (t ? t.address : undefined); }));
                    return [4 /*yield*/, getUsdValues(tokens)];
                case 2:
                    tokensWithUsd = _a.sent();
                    parsedOrders = orders.map(function (o) {
                        try {
                            return (0, store_1.parseOrderUi)(lib, tokensWithUsd, o);
                        }
                        catch (error) {
                            return undefined;
                        }
                    });
                    return [2 /*return*/, lodash_1.default.chain(lodash_1.default.compact(parsedOrders))
                            .orderBy(function (o) { return o.order.time; }, "desc")
                            .groupBy(function (o) { return o.ui.status; })
                            .value()];
            }
        });
    }); }, {
        enabled: !!lib && lodash_1.default.size(tokenList) > 0,
        refetchInterval: consts_1.REFETCH_ORDER_HISTORY,
        onError: function (error) { return console.log(error); },
        refetchOnWindowFocus: true,
        retry: 5,
    });
    return __assign(__assign({}, query), { orders: query.data || {}, isLoading: query.isLoading && query.fetchStatus !== "idle" });
};
exports.useOrdersHistoryQuery = useOrdersHistoryQuery;
var usePrepareUSDValues = function (_priceUsd) {
    var client = (0, react_query_1.useQueryClient)();
    var priceUsd = useGetPriceUsdCallback();
    var fetchUsdMutation = (0, react_query_1.useMutation)(function (token) {
        return _priceUsd ? _priceUsd(token) : priceUsd(token);
    }, {
        onError: function (error, token) { return console.debug({ error: error, token: token }); },
    }).mutateAsync;
    return function (tokens) {
        if (tokens === void 0) { tokens = []; }
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, Promise.allSettled(tokens.map(function (token) {
                        return client
                            .ensureQueryData({
                            queryKey: [enums_1.QueryKeys.GET_USD_VALUE, token.address],
                            queryFn: function () { return fetchUsdMutation(token); },
                        })
                            .then(function (usd) { return lodash_1.default.merge({}, token, { usd: usd }); });
                    })).then(function (results) { return lodash_1.default.compact(lodash_1.default.map(results, function (r) { return (r.status === "fulfilled" ? r.value : undefined); })); })];
            });
        });
    };
};
exports.usePrepareUSDValues = usePrepareUSDValues;
var useSetTokensFromDapp = function () {
    var context = (0, context_1.useTwapContext)();
    var srcTokenAddressOrSymbol = context.srcToken;
    var dstTokenAddressOrSymbol = context.dstToken;
    var setSrcToken = (0, store_1.useTwapStore)(function (state) { return state.setSrcToken; });
    var setDstToken = (0, store_1.useTwapStore)(function (state) { return state.setDstToken; });
    var tokensList = useTokenList();
    var tokensReady = lodash_1.default.size(tokensList) > 0;
    var wrongNetwork = (0, store_1.useTwapStore)(function (store) { return store.wrongNetwork; });
    return (0, react_1.useCallback)(function () {
        if (!tokensReady || wrongNetwork || wrongNetwork == null)
            return;
        if (srcTokenAddressOrSymbol) {
            var srcToken = (0, store_1.getTokenFromTokensList)(tokensList, srcTokenAddressOrSymbol);
            setSrcToken(srcToken);
        }
        if (dstTokenAddressOrSymbol) {
            var dstToken = (0, store_1.getTokenFromTokensList)(tokensList, dstTokenAddressOrSymbol);
            setDstToken(dstToken);
        }
    }, [srcTokenAddressOrSymbol, dstTokenAddressOrSymbol, tokensReady, wrongNetwork]);
};
exports.useSetTokensFromDapp = useSetTokensFromDapp;
var useParseTokens = function (dappTokens, parseToken) {
    var listLength = lodash_1.default.size(dappTokens);
    var parse = parseToken ? parseToken : function (t) { return t; };
    return (0, react_1.useMemo)(function () { return lodash_1.default.compact(lodash_1.default.map(dappTokens, parse)); }, [listLength]);
};
exports.useParseTokens = useParseTokens;
var useOrderPastEvents = function (order, enabled) {
    var lib = (0, store_1.useTwapStore)(function (store) { return store.lib; });
    var getPriceUsd = useGetPriceUsdCallback();
    var _a = (0, react_1.useState)(false), haveValue = _a[0], setHaveValue = _a[1];
    var _enabled = haveValue ? true : !!enabled;
    return (0, react_query_1.useQuery)(["useOrderPastEvents", order.order.id, lib === null || lib === void 0 ? void 0 : lib.maker, order.ui.progress], function () { return __awaiter(void 0, void 0, void 0, function () {
        var orderEndDate, _a, _b, _c, _d, orderStartBlock, orderEndBlock, _e, events, priceUsd1Token, dstAmountOut;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    _b = (_a = Math).min;
                    _c = [order.order.ask.deadline];
                    return [4 /*yield*/, (0, web3_candies_1.block)()];
                case 1:
                    orderEndDate = _b.apply(_a, _c.concat([(_f.sent()).timestamp]));
                    return [4 /*yield*/, Promise.all([(0, web3_candies_1.findBlock)(order.order.time * 1000), (0, web3_candies_1.findBlock)(orderEndDate * 1000)])];
                case 2:
                    _d = _f.sent(), orderStartBlock = _d[0], orderEndBlock = _d[1];
                    return [4 /*yield*/, Promise.all([
                            (0, web3_candies_1.getPastEvents)({
                                contract: lib.twap,
                                eventName: "OrderFilled",
                                filter: {
                                    maker: lib.maker,
                                    id: order.order.id,
                                },
                                fromBlock: orderStartBlock.number,
                                toBlock: orderEndBlock.number,
                                // maxDistanceBlocks: 2_000,
                            }),
                            getPriceUsd(order.ui.dstToken),
                        ])];
                case 3:
                    _e = _f.sent(), events = _e[0], priceUsd1Token = _e[1];
                    dstAmountOut = lodash_1.default.reduce(events, function (sum, event) {
                        return sum.plus(event.returnValues.dstAmountOut);
                    }, (0, bignumber_js_1.default)(0));
                    return [2 /*return*/, {
                            dstAmountOut: (0, store_1.amountUi)(order.ui.dstToken, dstAmountOut),
                            dstAmountOutUsdPrice: (0, store_1.amountUi)(order.ui.dstToken, dstAmountOut.times(priceUsd1Token)),
                        }];
            }
        });
    }); }, {
        enabled: !!lib && !!_enabled,
        retry: 5,
        staleTime: Infinity,
        onSuccess: function () { return setHaveValue(true); },
    });
};
exports.useOrderPastEvents = useOrderPastEvents;
var useFormatNumber = function (_a) {
    var _b;
    var value = _a.value, _c = _a.decimalScale, decimalScale = _c === void 0 ? 3 : _c, prefix = _a.prefix, suffix = _a.suffix;
    var result = (0, react_number_format_1.useNumericFormat)({
        allowLeadingZeros: true,
        thousandSeparator: ",",
        displayType: "text",
        value: value || "",
        decimalScale: decimalScale,
        prefix: prefix,
        suffix: suffix,
    });
    return (_b = result.value) === null || _b === void 0 ? void 0 : _b.toString();
};
exports.useFormatNumber = useFormatNumber;
var useSrcAmountNotZero = function () {
    var value = (0, store_1.useTwapStore)(function (store) { return store.getSrcAmount(); });
    return value.gt(0);
};
exports.useSrcAmountNotZero = useSrcAmountNotZero;
var useResetLimitPrice = function () {
    return (0, store_1.useTwapStore)(function (store) { return store.setLimitOrderPriceUi; });
};
exports.useResetLimitPrice = useResetLimitPrice;
var useTokenSelect = function () {
    var _a = (0, context_1.useTwapContext)(), onSrcTokenSelected = _a.onSrcTokenSelected, onDstTokenSelected = _a.onDstTokenSelected, parseToken = _a.parseToken;
    return (0, react_1.useCallback)(function (_a) {
        var isSrc = _a.isSrc, token = _a.token;
        var parsedToken = parseToken ? parseToken(token) : token;
        if (isSrc) {
            analytics_1.analytics.onSrcTokenClick(parsedToken === null || parsedToken === void 0 ? void 0 : parsedToken.symbol);
            store_1.useTwapStore.getState().setSrcToken(parsedToken);
            onSrcTokenSelected === null || onSrcTokenSelected === void 0 ? void 0 : onSrcTokenSelected(token);
        }
        else {
            analytics_1.analytics.onDstTokenClick(parsedToken === null || parsedToken === void 0 ? void 0 : parsedToken.symbol);
            store_1.useTwapStore.getState().setDstToken(parsedToken);
            onDstTokenSelected === null || onDstTokenSelected === void 0 ? void 0 : onDstTokenSelected(token);
        }
    }, [onSrcTokenSelected, onDstTokenSelected, parseToken]);
};
var useToken = function (isSrc) {
    var srcTokenLogo = (0, store_1.useTwapStore)(function (store) { return store.srcToken; });
    var dstTokenLogo = (0, store_1.useTwapStore)(function (store) { return store.dstToken; });
    return isSrc ? srcTokenLogo : dstTokenLogo;
};
exports.useToken = useToken;
var useSwitchTokens = function () {
    var _a = (0, context_1.useTwapContext)(), dappTokens = _a.dappTokens, onSrcTokenSelected = _a.onSrcTokenSelected, onDstTokenSelected = _a.onDstTokenSelected;
    var switchTokens = (0, store_1.useTwapStore)(function (s) { return s.switchTokens; });
    var srcToken = (0, store_1.useTwapStore)(function (s) { return s.srcToken; });
    var dstToken = (0, store_1.useTwapStore)(function (s) { return s.dstToken; });
    return (0, react_1.useCallback)(function () {
        switchTokens();
        var _srcToken = (0, store_1.getTokenFromTokensList)(dappTokens, (srcToken === null || srcToken === void 0 ? void 0 : srcToken.address) || (srcToken === null || srcToken === void 0 ? void 0 : srcToken.symbol));
        var _dstToken = (0, store_1.getTokenFromTokensList)(dappTokens, (dstToken === null || dstToken === void 0 ? void 0 : dstToken.address) || (dstToken === null || dstToken === void 0 ? void 0 : dstToken.symbol));
        srcToken && (onSrcTokenSelected === null || onSrcTokenSelected === void 0 ? void 0 : onSrcTokenSelected(_dstToken));
        dstToken && (onDstTokenSelected === null || onDstTokenSelected === void 0 ? void 0 : onDstTokenSelected(_srcToken));
    }, [lodash_1.default.size(dappTokens), srcToken === null || srcToken === void 0 ? void 0 : srcToken.address, srcToken === null || srcToken === void 0 ? void 0 : srcToken.symbol, dstToken === null || dstToken === void 0 ? void 0 : dstToken.address, dstToken === null || dstToken === void 0 ? void 0 : dstToken.symbol, onSrcTokenSelected, onDstTokenSelected]);
};
exports.useSwitchTokens = useSwitchTokens;
var useOrdersTabs = function () {
    var _a = (0, exports.useOrdersHistoryQuery)(), orders = _a.data, dataUpdatedAt = _a.dataUpdatedAt;
    var _orders = orders || {};
    var _b = (0, context_1.useTwapContext)().uiPreferences.orderTabsToExclude, orderTabsToExclude = _b === void 0 ? ["All"] : _b;
    return (0, react_1.useMemo)(function () {
        var keys = __spreadArray(["All"], lodash_1.default.keys(twap_1.Status), true);
        var res = lodash_1.default.filter(keys, function (it) { return !(orderTabsToExclude === null || orderTabsToExclude === void 0 ? void 0 : orderTabsToExclude.includes(it)); });
        var mapped = lodash_1.default.map(res, function (it) {
            var _a;
            if (it === "All") {
                return { All: lodash_1.default.size(lodash_1.default.flatMap(_orders)) || 0 };
            }
            return _a = {}, _a[it] = lodash_1.default.size(_orders[it]) || 0, _a;
        });
        return lodash_1.default.reduce(mapped, function (acc, it) { return (__assign(__assign({}, acc), it)); }, {});
    }, [dataUpdatedAt]);
};
exports.useOrdersTabs = useOrdersTabs;
var useSelectTokenCallback = function () {
    var _a, _b;
    var srcTokenAddress = (_a = (0, store_1.useTwapStore)(function (s) { return s.srcToken; })) === null || _a === void 0 ? void 0 : _a.address;
    var dstTokenAddress = (_b = (0, store_1.useTwapStore)(function (s) { return s.dstToken; })) === null || _b === void 0 ? void 0 : _b.address;
    var parseToken = (0, context_1.useTwapContext)().parseToken;
    var onTokenSelect = useTokenSelect();
    var switchTokens = (0, exports.useSwitchTokens)();
    return (0, react_1.useCallback)(function (args) {
        var parsedToken = parseToken ? parseToken(args.token) : args.token;
        if ((0, web3_candies_1.eqIgnoreCase)((parsedToken === null || parsedToken === void 0 ? void 0 : parsedToken.address) || "", srcTokenAddress || "") || (0, web3_candies_1.eqIgnoreCase)((parsedToken === null || parsedToken === void 0 ? void 0 : parsedToken.address) || "", dstTokenAddress || "")) {
            switchTokens();
            return;
        }
        onTokenSelect(args);
    }, [srcTokenAddress, dstTokenAddress, switchTokens, parseToken, onTokenSelect]);
};
exports.useSelectTokenCallback = useSelectTokenCallback;
var useDappRawSelectedTokens = function () {
    var dappTokens = (0, context_1.useTwapContext)().dappTokens;
    var tokensLength = lodash_1.default.size(dappTokens);
    var srcToken = (0, store_1.useTwapStore)(function (s) { return s.srcToken; });
    var dstToken = (0, store_1.useTwapStore)(function (s) { return s.dstToken; });
    var _srcToken = (0, react_1.useMemo)(function () {
        return (0, store_1.getTokenFromTokensList)(dappTokens, (srcToken === null || srcToken === void 0 ? void 0 : srcToken.address) || (srcToken === null || srcToken === void 0 ? void 0 : srcToken.symbol));
    }, [srcToken === null || srcToken === void 0 ? void 0 : srcToken.address, srcToken === null || srcToken === void 0 ? void 0 : srcToken.symbol, tokensLength]);
    var _dstToken = (0, react_1.useMemo)(function () {
        return (0, store_1.getTokenFromTokensList)(dappTokens, (dstToken === null || dstToken === void 0 ? void 0 : dstToken.address) || (dstToken === null || dstToken === void 0 ? void 0 : dstToken.symbol));
    }, [dstToken === null || dstToken === void 0 ? void 0 : dstToken.address, dstToken === null || dstToken === void 0 ? void 0 : dstToken.symbol, tokensLength]);
    return {
        srcToken: _srcToken,
        dstToken: _dstToken,
    };
};
exports.useDappRawSelectedTokens = useDappRawSelectedTokens;
var useSubmitButton = function (isMain) {
    var translations = (0, context_1.useTwapContext)().translations;
    var shouldUnwrap = (0, store_1.useTwapStore)(function (store) { return store.shouldUnwrap(); });
    var shouldWrap = (0, store_1.useTwapStore)(function (store) { return store.shouldWrap(); });
    var wrongNetwork = (0, store_1.useTwapStore)(function (store) { return store.wrongNetwork; });
    var maker = (0, store_1.useTwapStore)(function (store) { var _a; return (_a = store.lib) === null || _a === void 0 ? void 0 : _a.maker; });
    var disclaimerAccepted = (0, store_1.useTwapStore)(function (state) { return state.disclaimerAccepted; });
    var setShowConfirmation = (0, store_1.useTwapStore)(function (state) { return state.setShowConfirmation; });
    var showConfirmation = (0, store_1.useTwapStore)(function (state) { return state.showConfirmation; });
    var warning = (0, store_1.useTwapStore)(function (state) { return state.getFillWarning(translations); });
    var createOrderLoading = (0, store_1.useTwapStore)(function (state) { return state.loading; });
    var _a = (0, exports.useLoadingState)(), srcUsdLoading = _a.srcUsdLoading, dstUsdLoading = _a.dstUsdLoading;
    var _b = (0, exports.useApproveToken)(), approve = _b.mutate, approveLoading = _b.isLoading;
    var createOrder = (0, exports.useCreateOrder)().mutate;
    var allowance = (0, exports.useHasAllowanceQuery)();
    var _c = (0, exports.useUnwrapToken)(), unwrap = _c.mutate, unwrapLoading = _c.isLoading;
    var _d = (0, exports.useWrapToken)(), wrap = _d.mutate, wrapLoading = _d.isLoading;
    var connect = (0, context_1.useTwapContext)().connect;
    var wizardStore = (0, store_1.useWizardStore)();
    var _e = (0, exports.useChangeNetwork)(), changeNetworkLoading = _e.loading, changeNetwork = _e.changeNetwork;
    if (wrongNetwork)
        return {
            text: translations.switchNetwork,
            onClick: changeNetwork,
            loading: changeNetworkLoading,
            disabled: changeNetworkLoading,
        };
    if (!maker)
        return {
            text: translations.connect,
            onClick: connect ? connect : undefined,
            loading: false,
            disabled: false,
        };
    if (warning)
        return {
            text: warning,
            onClick: undefined,
            disabled: true,
            loading: false,
        };
    if (shouldUnwrap)
        return {
            text: translations.unwrap,
            onClick: unwrap,
            loading: unwrapLoading,
            disabled: unwrapLoading,
        };
    if (shouldWrap)
        return {
            text: translations.wrap,
            onClick: wrap,
            loading: wrapLoading,
            disabled: wrapLoading,
        };
    if (createOrderLoading) {
        return {
            text: "",
            onClick: function () {
                if (!showConfirmation) {
                    setShowConfirmation(true);
                }
                else {
                    wizardStore.setOpen(true);
                }
                analytics_1.analytics.onOpenConfirmationModal();
            },
            loading: true,
            disabled: false,
        };
    }
    if (allowance.isLoading || srcUsdLoading || dstUsdLoading) {
        return { text: "", onClick: undefined, loading: true, disabled: true };
    }
    if (allowance.data === false)
        return {
            text: translations.approve,
            onClick: approve,
            loading: approveLoading,
            disabled: approveLoading,
        };
    if (showConfirmation)
        return {
            text: translations.confirmOrder,
            onClick: createOrder,
            loading: createOrderLoading,
            disabled: isMain ? true : !disclaimerAccepted || createOrderLoading,
        };
    return {
        text: translations.placeOrder,
        onClick: function () {
            setShowConfirmation(true);
            analytics_1.analytics.onOpenConfirmationModal();
        },
        loading: false,
        disabled: false,
    };
};
exports.useSubmitButton = useSubmitButton;
